import React from 'react';
import { EditSubcategoryRestaurantPropertiesState } from './editSubcategoryRestaurantPropertiesState/EditSubcategoryRestaurantPropertiesState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';

export const EditSubcategoryRestaurantPropertiesPage: React.FC = () => {
	return (
		<EditSubcategoryRestaurantPropertiesState>
			<Forms />
			<ModalWindows />
		</EditSubcategoryRestaurantPropertiesState>
	);
};
